import React from 'react';
import { Other } from 'simplydo/interfaces';

const PinIdeaHelper = ({
  challenge,
} : {
  challenge: {
    ideaVisibilityLimits?: Other.IChallenge['ideaVisibilityLimits'];
  }
}) => (
  <div>
    <p>Pinning an idea places it at the top of the idea list for anyone viewing this challenge's ideas.</p>
    {challenge.ideaVisibilityLimits?.length
      ? (
        <p>In this challenge, ideas are only shown to non-challenge-administrators if they are: <b>{challenge.ideaVisibilityLimits.map((iv) => iv.charAt(0).toUpperCase() + iv.slice(1)).join(', ')}</b></p>
      ) : null
    }
  </div>
);

export default PinIdeaHelper;
